var map = {
	"./address.svg": "9886",
	"./briefcase.svg": "81a4",
	"./broker.svg": "1e45",
	"./contact.svg": "b392",
	"./credit-card.svg": "2f82",
	"./group.svg": "a2cb",
	"./key.svg": "9c19",
	"./personal-information.svg": "be32",
	"./puzzle.svg": "d229",
	"./register.svg": "8d39",
	"./success.svg": "3255",
	"./user-data.svg": "adec",
	"./verification.svg": "ee9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5eb9";